import React from 'react'
import { Modal } from '@enamelai/design-system'
import { Icon as Delete2Icon } from '@enamelai/design-system/icons/Delete2'

type PhoneManagementDeleteExtensionModalProps = {
  show: boolean
  extensionNumber: string
  extensionName?: string
  onCancel: () => void
  onDelete: () => void
  deleteDisabled?: boolean
}

const PhoneManagementDeleteExtensionModal: React.FC<
  PhoneManagementDeleteExtensionModalProps
> = ({
  show,
  extensionNumber,
  extensionName,
  onCancel,
  onDelete,
  deleteDisabled = false,
}) => {
  const numberLabel = extensionNumber.trim() || 'this'
  const nameLabel = extensionName?.trim()
  const question = nameLabel
    ? `Are you sure you want to delete extension ${numberLabel} (${nameLabel})?`
    : `Are you sure you want to delete extension ${numberLabel}?`

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="sm"
      variant="confirmation"
      title="Delete extension"
      icon={<Delete2Icon width={16} height={16} aria-hidden="true" />}
      iconTone="danger"
      description={[
        question,
        'Call routing that relies on this extension may stop working until you add a new extension or update your settings. Do you want to continue?',
      ]}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      primaryDisabled={deleteDisabled}
      onPrimaryClick={() => {
        onDelete()
        onCancel()
      }}
      onSecondaryClick={onCancel}
    />
  )
}

export default PhoneManagementDeleteExtensionModal
